import { render, staticRenderFns } from "./NewsNutraceuticalBusiness.vue?vue&type=template&id=425e4239&scoped=true&"
import script from "./NewsNutraceuticalBusiness.vue?vue&type=script&lang=js&"
export * from "./NewsNutraceuticalBusiness.vue?vue&type=script&lang=js&"
import style0 from "./NewsNutraceuticalBusiness.vue?vue&type=style&index=0&id=425e4239&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425e4239",
  null
  
)

export default component.exports